module.exports = __webpack_public_path__ + "img/right.28861f38.png";